import React from 'react';

const MaintenancePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-canvas-default flex items-center justify-center px-4">
      <div className="max-w-sm w-full text-center">
        {/* Simple Logo */}
        <div className="mb-8">
          <div className="mx-auto w-20 h-20 bg-brand-primary rounded-full flex items-center justify-center mb-4">
            <span className="text-white text-2xl font-bold">VP</span>
          </div>
          <h1 className="text-2xl font-bold text-brand-dark">VetPintar</h1>
        </div>

        {/* Simple Message */}
        <h2 className="text-xl font-semibold text-slate-800 mb-3">
          Sedang dalam Perbaikan
        </h2>

        <p className="text-slate-600 mb-8">
          Kami sedang meningkatkan sistem untuk memberikan pelayanan yang lebih baik.
        </p>

        {/* Simple Retry Button */}
        <button
          onClick={() => window.location.reload()}
          className="w-full px-6 py-3 bg-brand-primary hover:bg-brand-secondary text-white font-medium rounded-lg transition-colors duration-200"
        >
          Coba Lagi
        </button>

        {/* Simple Contact Info */}
        <div className="mt-6 text-sm text-slate-500">
          <p>Butuh bantuan? Hubungi kami di</p>
          <p className="font-medium text-brand-primary">help@vetpintar.com</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;